import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import MessageApi from '@/components/message-api.vue';
import { NConfigProvider, NMessageProvider } from 'naive-ui';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      var _component_router_view = _resolveComponent("router-view");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(NMessageProvider), null, {
        default: _withCtx(function () {
          return [_createVNode(MessageApi)];
        }),
        _: 1
      }), _createVNode(_unref(NConfigProvider), {
        "theme-overrides": _ctx.themeOverrides
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_router_view)];
        }),
        _: 1
      }, 8, ["theme-overrides"])], 64);
    };
  }
});